// extracted by mini-css-extract-plugin
export var alt = "search-module--alt--1c186";
export var filterTagRow = "search-module--filter-tag-row--98533";
export var filterTagRowWrap = "search-module--filter-tag-row-wrap--ca1d2";
export var filterTagsSelected = "search-module--filter-tags-selected--1238a";
export var filterTagsWrap = "search-module--filter-tags-wrap--55284";
export var filterTagsWrapAlt = "search-module--filter-tags-wrap-alt--ed234";
export var filterToggle = "search-module--filter-toggle--c4eb4";
export var filterToggleIcon = "search-module--filter-toggle-icon--ea95a";
export var search = "search-module--search--4e110";
export var searchBrowseWrap = "search-module--search-browse-wrap--a2263";
export var searchBrowseWrapFilters = "search-module--search-browse-wrap-filters--ca466";
export var searchFiltersActive = "search-module--search-filters-active--79883";
export var searchWrap = "search-module--search-wrap--b09ec";